module.exports = __webpack_public_path__ + "static/media/menu-ouvert.bebcd771.svg";